<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

/**
 * 应用根组件
 * 处理全局状态和响应式检测
 */
export default {
  name: 'App',
  computed: {
    ...mapState(['token'])
  },
  async mounted() {
    // 初始化移动端检测
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    
    // 如果存在token但没有用户信息，则获取用户信息
    if (this.token && !this.$store.state.user) {
      try {
        await this.getCurrentUser()
      } catch (error) {
        console.warn('获取用户信息失败:', error)
        // 如果获取用户信息失败，可能是token过期，清除认证状态
        if (error.message.includes('401') || error.message.includes('登录')) {
          this.$store.dispatch('logout')
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    ...mapActions(['checkMobile', 'getCurrentUser'])
  }
}
</script>

<style>
#app {
  height: 100%;
}
</style>
